import {ads, RewardedAdProvider} from '../utils/uber-sdk/advertising.js';

import {AdAction, AdError, AdType} from '../utils/game-analytics-enums.js';

import type {GameAnalytics as GA} from 'gameanalytics';
import {gameState} from '../state/GameState.js';
declare var GameAnalytics: typeof GA;

export function showRewardedAd({e}: {x: number; y: number; e: MouseEvent}): Promise<any> {
    gameState.pause();
    const start = Date.now();
    return ads
        .showRewardedAd(e)
        .then((provider: RewardedAdProvider) => {
            const elapsedTime = Date.now() - start;
            GameAnalytics.addAdEventWithDuration(
                AdAction.Show,
                AdType.RewardedVideo,
                provider.name,
                'hud',
                elapsedTime
            );
            GameAnalytics.addAdEvent(
                AdAction.RewardReceived,
                AdType.RewardedVideo,
                provider.name,
                'hud'
            );
        })
        .catch((e: {provider: RewardedAdProvider; status: string}) => {
            let adError: AdError | null = AdError.Unknown;
            switch (e.status) {
                case 'ads-unavailable':
                    adError = AdError.NoFill;
                    break;
                case 'network-error':
                    adError = AdError.Offline;
                    break;
                case 'no-zoneid':
                    adError = AdError.InvalidRequest;
                    break;
                case 'ad-maximum':
                case 'ad-blocker':
                case 'ad-violation':
                case 'cors-error':
                    break;
                default:
                    adError = null;
                /* Not an error, user might just have canceled */
            }

            if (adError !== null) {
                GameAnalytics.addAdEventWithNoAdReason(
                    AdAction.FailedShow,
                    AdType.RewardedVideo,
                    e.provider.name,
                    'hud',
                    adError
                );
            }

            /* Rethrow to ensure no reward is given */
            throw e;
        })
        .finally(() => {
            gameState.resume();
        });
}
